var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3227_13403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.40006 1.65H7.65006V2.4V3.11274C7.36071 3.01891 7.06021 2.94784 6.75006 2.90342V1.85963C6.75006 1.22529 7.24457 0.75 7.80006 0.75H22.2001C22.7556 0.75 23.2501 1.22529 23.2501 1.85963V13.7404C23.2501 14.3747 22.7556 14.85 22.2001 14.85H13.5769C13.4578 14.5348 13.3109 14.234 13.1393 13.95H14.4001H15.1501V13.2V11.55H18.4501V13.2V13.95H19.2001H21.6001H22.3501V13.2V2.4V1.65H21.6001H8.40006ZM8.85006 8.4C8.85006 9.97404 7.5741 11.25 6.00006 11.25C4.42602 11.25 3.15006 9.97404 3.15006 8.4C3.15006 6.82596 4.42602 5.55 6.00006 5.55C7.5741 5.55 8.85006 6.82596 8.85006 8.4Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3227_13403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19.2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsk);
export default __webpack_public_path__ + "static/media/ask.2712f896d2fbea994f859a649062e401.svg";
export { ForwardRef as ReactComponent };